export enum PaymentType {
    
    Check=0, 
    
    Cash=1, 
}


